import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=804fa67c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=804fa67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804fa67c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('804fa67c')) {
      api.createRecord('804fa67c', component.options)
    } else {
      api.reload('804fa67c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=804fa67c&scoped=true&", function () {
      api.rerender('804fa67c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hfYJKuXGU71W/JS/comp/PopupBox.vue"
export default component.exports